import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import CustomPropertyCell from "components/CustomPropertyCell";
import { CustomDocumentProperty, DocumentIntake, DocumentIntakeViewBasic } from "generated/graphql";
import { useState } from "react";
import produce from "immer";
import useAppDispatchWithSnackbar from "helpers/hooks/useAppDispatchWithSnackbar";
import { CustomPropertyValue, customPropertiesToUI, customPropertiesFromUI } from "helpers/customProperties";
import { updateIntakeCustomProperties } from "redux/slices/case";

interface Props {
  open: boolean;
  close: () => void;
  intake: DocumentIntake | DocumentIntakeViewBasic;
  documentProperties: CustomDocumentProperty[];
}

const EditDocumentPropertiesDialog = (props: Props) => {
  const [editing, setEditing] = useState(false);
  const { open, close, intake, documentProperties } = props;
  const [documentPropertyValues, setDocumentPropertyValues] = useState<Record<string, CustomPropertyValue>>(
    customPropertiesToUI(documentProperties, intake.properties)
  );
  const snackpatch = useAppDispatchWithSnackbar();

  const editProperties = async () => {
    setEditing(true);
    snackpatch(
      updateIntakeCustomProperties({
        intakeId: intake.id,
        properties: customPropertiesFromUI(documentPropertyValues),
      }),
      {
        successMessage: "Properties updated successfully",
        errorMessage: "Unable to update update properties",
      }
    ).then(() => close());
  };
  return (
    <Dialog open={open} onClose={close}>
      <DialogTitle>Edit Properties for {intake.name}</DialogTitle>
      <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, pt: "16px!important" }}>
        {documentProperties.map((dp) => (
          <CustomPropertyCell
            key={dp.key}
            customProperty={dp}
            value={documentPropertyValues[dp.key]}
            setValue={(v) =>
              setDocumentPropertyValues((prev) =>
                produce(prev, (draft) => {
                  draft[dp.key] = v;
                })
              )
            }
          />
        ))}
      </DialogContent>
      <DialogActions>
        <Button color="default" onClick={close}>
          Cancel
        </Button>
        <Button color="warning" variant="contained" disabled={editing} onClick={editProperties}>
          {editing ? "Saving" : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditDocumentPropertiesDialog;
